var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import ShareDetails from './share-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ShareDetails on Property {\n    listing {\n      peopleWanted\n      roomsAvailable\n      currentOccupants\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing;
  return {
    numPeopleWanted: listing.peopleWanted,
    numRoomsAvailable: listing.roomsAvailable,
    numCurrentOccupants: listing.currentOccupants
  };
};
var ShareDetailsGraphQL = _ref2 => {
  var property = _ref2.property;
  return ___EmotionJSX(ShareDetails, graphQLToProps(property));
};
ShareDetailsGraphQL.fragment = fragment;
ShareDetailsGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      peopleWanted: PropTypes.number,
      roomsAvailable: PropTypes.number,
      currentOccupants: PropTypes.number
    })
  })
};
ShareDetailsGraphQL.defaultProps = {
  property: {}
};
export default ShareDetailsGraphQL;